import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from '@ionic/vue'
import { homeOutline } from 'ionicons/icons'



export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: ['pageTitle'],
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), { translucent: true }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonButtons), { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonBackButton)),
              _createVNode(_unref(IonMenuButton), { color: "primary" })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonTitle), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.pageTitle), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonButtons), { slot: "end" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default"),
              _createVNode(_unref(IonButton), {
                class: "ion-no-margin",
                href: "/home",
                "router-direction": "root"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    color: "primary",
                    icon: _unref(homeOutline)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})